import { render, staticRenderFns } from "./PortfolioScenariosPage.vue?vue&type=template&id=0cc7f02e"
import script from "./PortfolioScenariosPage.vue?vue&type=script&lang=ts"
export * from "./PortfolioScenariosPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports